activ.directive('displayListView', function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: "./views/displayListView.html?v=" + version,
        scope: true,
        link: function(scope, element, attrs, ngModel) {
        }
    };
});